import { IconCurrencyCircleDollar, Text } from '@vtex/admin-ui'
import { useAdmin } from '@vtex/raccoon-next'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  Tag,
} from 'ui'
import { BenefitViewComponentBaseProps } from '.'
import { type MaximumUnitPriceDiscount } from '../../../../../../typings'
import { messages } from '../messages'

export function MaxUnitPriceBenefit(
  props: BenefitViewComponentBaseProps<MaximumUnitPriceDiscount>
) {
  const { config, onEdit, onRemove } = props

  const { currency } = useAdmin()

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconCurrencyCircleDollar />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.maxUnitPrice.description}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Tag>
          <FormattedNumber
            value={config.price}
            style="currency"
            currency={currency}
          />
        </Tag>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
